"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PPF_TRIGGER_THREASHOLD_MULTIPLYER = exports.SMS_SIM_CARD_DEFAULT_SELECTION_ECHAIN_ID = exports.SMS_SENSOR_CABLE_DEFAULT_LENGTH_M = exports.SWITCH_CABINET_DEFAULT_DISTANCE_M = exports.SWITCH_CABINET_CABLE_EXTRA_LENGTH_M = void 0;
exports.SWITCH_CABINET_CABLE_EXTRA_LENGTH_M = 0.5;
exports.SWITCH_CABINET_DEFAULT_DISTANCE_M = 1;
exports.SMS_SENSOR_CABLE_DEFAULT_LENGTH_M = 3;
exports.SMS_SIM_CARD_DEFAULT_SELECTION_ECHAIN_ID = 'f8c90f48-503b-54a1-94a4-6d9c77fac00c';
exports.PPF_TRIGGER_THREASHOLD_MULTIPLYER = 3;
//# sourceMappingURL=SmartPlasticsConfiguration.js.map